import React from 'react';
import { defaultFill } from '../utils/constants';
var muiCheckMark16 = {
    // Check mark is a polygon. No path needed.
    paths: [],
    pathsWrapper: function (_a) {
        var fill = _a.fill;
        return (React.createElement("g", { fill: fill || defaultFill },
            React.createElement("polygon", { points: "0 6 2 4 4 6 10 0 12 2 4 10" })));
    },
    title: 'Check Mark',
    width: 12,
    height: 10,
};
var muiCheckMark24 = {
    // Check mark is a polygon. No path needed.
    paths: [],
    pathsWrapper: function (_a) {
        var fill = _a.fill;
        return (React.createElement("g", { fill: fill || defaultFill },
            React.createElement("polygon", { points: "0 12 4 8 8 12 20 0 24 4 8 20" })));
    },
    title: 'Check Mark',
    width: 24,
    height: 20,
};
var muiCheckMark = {
    base: muiCheckMark16,
    smIcon: muiCheckMark16,
    lgIcon: muiCheckMark24,
};
export { muiCheckMark };
//# sourceMappingURL=checkMark.js.map